// In dev, use relative path so Vite proxy handles it (avoids CORS issues with localhost)
const base = () => import.meta.env.DEV ? '' : import.meta.env.VITE_API_SEARCH_URL;

export const getNotifications = async (callProtectedApi, page = 1, size = 20) => {
  const res = await callProtectedApi(`${base()}/api/notifications?page=${page}&size=${size}`);
  return res?.data;
};

export const getUnreadCount = async (callProtectedApi) => {
  const res = await callProtectedApi(`${base()}/api/notifications/unread-count`);
  return res?.data;
};

export const markAsRead = async (callProtectedApi, id) => {
  const res = await callProtectedApi(`${base()}/api/notifications/${id}/read`, { method: "PATCH" });
  return res?.data;
};

export const markAllAsRead = async (callProtectedApi) => {
  const res = await callProtectedApi(`${base()}/api/notifications/read-all`, { method: "POST" });
  return res?.data;
};

export const deleteNotification = async (callProtectedApi, id) => {
  const res = await callProtectedApi(`${base()}/api/notifications/${id}`, { method: "DELETE" });
  return res?.data;
};

export const clearAllNotifications = async (callProtectedApi) => {
  const res = await callProtectedApi(`${base()}/api/notifications/clear-all`, { method: "POST" });
  return res?.data;
};
